import es from './es.json'

const general = {
  attention: 'Atención',
  select_option: 'Seleccione una opción',
  value: 'Valor',
  name: 'Nombre',
  placeholder: 'Indicación',
  title: 'Título',
  title_group: 'Título del grupo',
  subtitle: 'Subtítulo',
  text: 'Texto',
  list: 'Lista',
  boolean: 'Booleano',
  type: 'Tipo',
  action: 'Acción',
  property: 'Propiedad',
  logic: 'Lógico',
  permanent: 'Permanente',
  size: 'Tamaño',
  available_sizes: 'Tamaños admitidos',
  available_in: 'Disponible en',
  variant: 'Variante',
  right: 'Derecha',
  left: 'Izquierda',
  option: 'Opción',
  options: 'Opciones',
  validations: 'Validaciones',
  equal: 'igual',
  different: 'diferente',
  higher: 'mayor',
  greater_than_or_equal: 'mayor o igual',
  less: 'menor',
  less_than_or_equal: 'menor o igual',
  settings: 'Configuración',
  none: 'Ninguno',
  every: 'Todos',
  today: 'Hoy',
  email: 'Email',
  date: 'Fecha',
  peview: 'Visualización',
  default_option: 'Opción por defecto',
  default_value: 'Valor por defecto',
  all_options_by_default: 'Todas las opciones pre-cargadas por defecto',
  small: 'Pequeño',
  medium: 'Mediano',
  large: 'Grande',
  multiple: 'Múltiple',
  data_origin: 'Origen de datos',
  users: 'Usuarios',
  areas: 'Áreas',
  description: 'Descripción',
  variable: 'Variable',
  variables: 'Variables',
  actions: 'Acciones',
  // Permissions
  action_deny_by_insufficient_permissions: 'Lo sentimos, no tiene permisos para guardar los cambios.',
  // Document types
  generic: 'Genérico',
  specific: 'Específco',
  comunicable: 'Comunicable',
  incomunicable: 'No Comunicable',
  public: 'Público',
  private: 'Privado',
  electronic: 'Electrónica',
  digital: 'Digital',
  prefix: 'Prefijo',
  id: 'ID',
  reject: 'Rechazar',
  view_more: 'Ver Más',
  login_again: 'Ingresar nuevamente',
  go_back: 'Volver',
  volver: 'Volver',
  address: 'Dirección',
  // User details datatables
  hide_details: 'Ocultar detalles',
  show_details: 'Mostrar detalles',
  login_history: 'Historial de Logueo',
  audit: 'Auditoría',
  external: 'Externo',
  inperson: 'Presencial',
  try_again: 'Volver a intentar',
  talk_to_admin: 'Habla con el administrador o dejanos un mensaje en el chat.',
  view: 'Ver',
  good_title: '¡Bien!',
  something_went_wrong: 'Algo salió mal',
  review_before_trying_again: 'Revisa y modifica antes de volver a intentar',
  error_found: 'Encontramos un error',
  accept: 'Aceptar',
  i_will_do_it_later: 'Lo haré luego',
  continue: 'Continuar',
  continue_confirmation: '¿Está seguro que desea continuar?',
  more_details: 'Más detalles',
  number: 'Número',
  copied: 'Copiado!',
  action_done_successfully: 'Acción realizada con éxito',
  it_was_successfully_reactivated: 'Se reactivó correctamente',
  permits_have_not_been_selected_for_the_procedures: 'Todavía no se han seleccionado permisos para los trámites.',
  reload: 'Recargar',
  refresh: 'Refrescar',
  reject_procedure: 'Rechazar trámite',
  are_you_sure_you_want_to_reject_this_procedure: '¿Estas seguro de que deseas rechazar este trámite?',
  delete_procedure: 'Eliminar trámite',
  are_you_sure_you_want_to_delete_this_procedure: '¿Estas seguro de que deseas eliminar este trámite?  Esta acción no puede deshacerse.',
  personalization: 'Personalización',
  common: 'Generales',
  adjustment: 'Ajustes'
}

const library = {
  documents_library: 'Biblioteca de documentos',
  documents_type: 'Tipo de documentos',
  name_of_library: 'Nombre de la librería',
  library_configuration: 'Configuración de biblioteca',
  document_types: 'Tipos de Documentos',
  upload_document_types: 'Cargar tipos de documentos',
  header_color: 'Color del encabezado',
  success_edit_library: 'La librería se editó con éxito',
  success_add_library: 'La librería se agregó con éxito',
  success_create_library: 'Se creó la librería correctamente',
  documents: 'documentos',
  url_library: 'Url de la biblioteca'
}

const groupUsers = {
  user_groups: 'Grupos de usuarios',
  user_that_make_up_the_group: 'Usuario que conforman el grupo',
  add_users_to_be_able_to_create_a_new_group: 'Agrega usuarios para poder crear un nuevo grupo.',
  who_can_make_passes_to_this_group: 'Quiénes pueden hacer pases a este grupo',
  select_who_can_make_passes_to_this_group: 'Seleccione quiénes pueden hacer pases a este grupo. Si no especifica un área o usuario todos pueden hacer pases.',
  you_are_about_to_delete_the_group: 'Está por eliminar el grupo.',
  you_are_about_to_reactivate_the_group: 'Está por reactivar el grupo.',
  group_saved_successfully: 'Se guardó correctamente el grupo',
  group_was_successfully_deleted: 'Se eliminó correctamente el grupo',
  the_group_was_successfully_reactivated: 'Se reactivó el grupo correctamente.'
}

const groupReviewers = {
  reviewer_groups: 'Grupos de revisores',
  reviewer_that_make_up_the_group: 'Revisores que conforman el grupo',
  add_reviewers_to_be_able_to_create_a_new_group: 'Agrega usuarios para poder crear un nuevo grupo.',
  who_can_make_passes_to_this_reviewer_group: 'Quiénes pueden hacer pases a este grupo',
  select_who_can_make_passes_to_this_reviewer_group: 'Seleccione quiénes pueden hacer pases a este grupo. Si no especifica un área o usuario todos pueden hacer pases.',
  you_are_about_to_delete_the_reviewer_group: 'Está por eliminar el grupo.',
  you_are_about_to_reactivate_the_reviewer_group: 'Está por reactivar el grupo.',
  reviewer_group_saved_successfully: 'Se guardó correctamente el grupo',
  reviewer_group_was_successfully_deleted: 'Se eliminó correctamente el grupo',
  the_reviewer_group_was_successfully_reactivated: 'Se reactivó el grupo correctamente.',
  allow_reviewers_groups: 'Permitir Grupos de Revisores'
}

const groupProfile = {
  profile_groups: 'Grupos de perfiles',
  profile_that_make_up_the_group: 'Perfiles que conforman el grupo',
  add_profile_to_be_able_to_create_a_new_group: 'Agrega usuarios para poder crear un nuevo grupo.',
  you_are_about_to_delete_the_profile_group: 'Está por eliminar el grupo.',
  you_are_about_to_reactivate_the_profile_group: 'Está por reactivar el grupo.',
  profile_group_saved_successfully: 'Se guardó correctamente el grupo',
  profile_group_was_successfully_deleted: 'Se eliminó correctamente el grupo',
  the_profile_group_was_successfully_reactivated: 'Se reactivó el grupo correctamente.'
}

const accion = {
  save: 'Guardar',
  save_as: 'Guardar como',
  save_and_pass: 'Guardar y hacer un pase',
  edit: 'Editar',
  custom_edit: 'Editar {objectName}',
  save_or_update: 'Guardar o Actualizar',
  save_as_template: 'Guardar como Template',
  success_saved: 'Se guardó exitosamente',
  update: 'Guardar',
  delete: 'Eliminar',
  takeoff: 'Quitar',
  delete_logic: 'Dar de baja',
  erase: 'Borrar',
  view_library: 'Ver biblioteca',
  restore_logic: 'Dar de alta',
  defuse: 'Desactivar',
  activate: 'Activar',
  cancel: 'Cancelar',
  publish: 'Publicar',
  add: 'Agregar',
  add_param: 'Agregar parámetro',
  add_option: 'Agregar opción',
  add_field: 'Agregar campo',
  selected: 'Seleccionado',
  disabled: 'Deshabilitado',
  required: 'Requerido',
  select_an_option: 'Seleccione una opción',
  depends_of: 'Depende de',
  create: 'Crear',
  update_literal: 'Actualizar',
  show_preview: 'Mostrar Previsualización',
  show_variables: 'Mostrar variables',
  copy_to_clipboard: 'Copiar al porta papeles',
  add_condition: 'Agregar condición',
  add_group: 'Agregar grupo',
  comment: 'Comentar',
  allow: 'Permitir',
  not_allow: 'No permitir',
  next: 'Siguiente',
  previous: 'Anterior',
  reopen: 'Reabrir',
  request_start: 'Solicitar iniciar',
  reactivate: 'Reactivar'
}

const formbuilderView = {
  form_with_errors: 'Faltan campos obligatorios',
  form_builder: 'Generador de formularios',
  general_settings: 'Configuración general',
  form_title: 'Título del formulario',
  form_alias: 'Alias',
  endpoint_to_manage_all_requests: 'Endpoint para solicitudes GET, POST, PUT y DELETE',
  endpoint_to_manage_all_requests_help: 'A menos que se especifique lo contrario, este endpoint maneja todos los request al servidor',
  path_to_redirect: 'Ruta para redirección',
  success_action_message_setter: 'Mensaje de acción exitosa',
  is_internal_form: 'Es un formulario interno',
  edit_mode: 'Edición',
  view_config: 'Ver configuración',
  preview_mode: 'Previsualización',
  form_fields: 'Campos del formulario',
  form_must_have_at_least_one_field: 'El formulario debe tener al menos un elemento.',
  add_field_to_form: 'Agregar un campo al formulario',
  watch_saved_form_here: 'Puedes ver el formulario aquí',
  view_modes: 'Modos de visualizar'
}

const formbuilderComponents = {
  post_path: 'POST Path',
  put_path: 'PUT Path',
  delete_type: 'Tipo de borrado',
  delete_path: 'DELETE Path',
  comp_columns: 'Columnas',
  comp_icon: 'Icono',
  comp_icon_position: 'Posición del icono',
  comp_styles: 'Estilos',
  require_confirmation: 'Requiere confirmación',
  confirmation_title_setter: 'Título de la confirmación',
  confirmation_message_setter: 'Mensaje de la confirmación',
  prop_to_manage_logic_delete: 'Propiedad que se edita para el borrado lógico',
  custom_params: 'Parámetros personalizados',
  comp_title_help: 'Título que se mostrará sobre el campo',
  checkbox_label_help: 'Nombre usado para la visibilidad basada en una condición',
  comp_name_help: 'Nombre interno para guardar el valor del campo en el sistema',
  comp_placeholder_help: 'Texto indicativo que aparecerá en el campo cuando se comience a completar el formulario',
  comp_size_help: 'Tamaño del componente',
  comp_variant_help: 'Seleccione una variante para el componente',
  comp_type_help: 'Seleccione un tipo de componente',
  checkbox_simple_label: 'Texto para Checkbox simple',
  checkbox_uncheck_value: 'Valor Sin Chequear',
  checkbox_label_position: 'Posición del título',
  comp_invalid_text_setter: 'Texto de campo inválido',
  comp_valid_text_setter: 'Texto de campo válido',
  color_picker_label: 'Color por defecto',
  desktop_view_width: 'Ancho vista escritorio',
  value_has_to_be_equal_to: 'El valor tiene que ser igual a',
  visible_only_on_edit_mode: 'Visible solo en modo edición',
  disabled_only_on_edit_mode: 'Deshabilitado solo en modo edición',
  helper_text_setter: 'Texto de ayuda',
  helper_text_setter_help: 'Ayuda para el usuario sobre el campo a completar (igual a este mensaje)',
  comp_min_date: 'Fecha mínima',
  comp_format_date: 'Formato de fecha',
  subtitle_placeholder_example: 'Un Subtítulo de ejemplo',
  comp_post_endpoint_setter: 'Endpoint para el POST',
  comp_post_endpoint_help: 'Endpoint para los request al servidor al cargar un archivo',
  comp_initial_latitude: 'Latitud Inicial',
  comp_initial_length: 'Longitud Inicial',
  map_height: 'Altura',
  comp_is_vertical: 'En vertical',
  comp_radios: 'Radios',
  comp_buttons: 'Botones',
  comp_numeration: 'Numeración',
  button_text: 'Texto del botón',
  min_length: 'Longitud mínima',
  max_length: 'Longitud máxima',
  max_files_allow: 'Cantidad máxima de archivos',
  max_files_allow_help: 'Indicar 0 deshabilita el componente',
  file_types_allow: 'Tipos de archivos permitidos',
  file_max_size_allow: 'Tamaño máximo (en MB)',
  only_unique_files: 'Solo archivos únicos',
  set_my_privileges: 'Setear mis privilegios',
  set_all_privileges: 'Setear todos los privilegios',
  signers_options_origin_setter_help: 'Usuarios que se mostrarán como opciones para firmar',
  width_digital_signature: 'Con firma digital',
  select_elemet_type: 'Seleccione el tipo de elemento',
  preview_path: 'Path para la previsualización',
  preview_button: 'Botón de previsualización',
  customize_this_title: 'Personaliza este título presionando "Editar Dashboard"',
  // Nombres de componentes
  LmCodeInput: 'Campo de código',
  LmTreeSelect: 'Selector en árbol',
  cannot_be_undone: 'Esta acción no puede deshacerse',
  // LmUploadImage
  upload_image: 'Subir una Imagen',
  select_file: 'Elija un archivo...',
  browse: 'Buscar',
  // LmReaderInput
  write_a_text_for_variable: 'Escriba un texto para completar la variable.'
}

const documenttypesView = {
  document_types_generator: 'Generador de Tipos de documento',
  document_type_name: 'Nombre del Tipo de Documento',
  document_type_name_placeholder: 'Ingrese el nombre del Tipo de Documento',
  document_type_alias: 'Alias del Tipo de Documento',
  document_type_alias_placeholder: 'Ingrese el alias del Tipo de Documento',
  document_type_description: 'Descripción del Documento',
  document_type_description_placeholder: 'Esta descripción se mostrará como ayuda durante el alta del documento',
  numerator_type: 'Tipo de Numerador',
  comunicable_type: 'Tipo de Comunicación',
  visibility_type: 'Tipo de Visibilidad',
  signature_type: 'Tipo de Firma',
  header_type_position: 'Posición del encabezado',
  header_type_position_help: 'Define si el encabezado del PDF se coloca al principio del documento o al final (antes de las firmas)',
  numerator_prefix: 'Prefjo para numeración',
  allow_reviewers: 'Permitir revisores',
  allow_in_person: 'Permitir firmantes presenciales',
  allow_internal: 'Permitir firmantes internos',
  allow_external_participants: 'Permitir participantes externos',
  allow_external_recipients: 'Permitir destinatarios externos',
  allow_reviewers_type_help: 'Esta opción habilita la posibilidad de incluir visadores en el flujo de un documento.',
  allow_external_recipients_type_help: 'Esta opción permite incluir destinatarios externos al flujo de un documento.',
  allow_external_participants_type_help: 'Esta opción permite incluir participantes externos al flujo de un documento.',
  numerator_prefix_help: 'Grupo de letras que se antepondrán al número del documento para identificarlo',
  numerator_type_help: 'Esta opción permite definir si los documentos de este tipo serán numerados con un numerador específico (por ejemplo, los Decretos) o si se utilizará un numerador genérico',
  comunicable_type_help: 'Si un documento es comunicable, el usuario tendrá la posibilidad de seleccionar destinatarios a los que se informará cuando el documento esté finalizado',
  visibility_type_help: 'Los documentos Privados solo pueden ser vistos por su creador, por el destinatario del documento si existe y por cualquier otra persona o área que el creador seleccione. Si se seleccion esta opción, al crear un documento, el usuario podrá indicar los usuarios o áreas habilitados a visualizarlo',
  comments_type_help: 'Esta opción permite habilitar y administrar los comentarios para este tipo de documento.',
  signature_type_help: 'Esta opción permite indicar si el documento deberá ser firmado de manera Digital o Electrónica. De indicarse Firma Digital solo habilitarán para firmar los usuarios que tengan asociado este tipo de firma en su perfil',
  import_form_components_from_another_document_type: 'Cargar campos desde otro tipo de documento',
  publish_confirmation_title: '¿Estás seguro de publicar este Tipo de Documento?',
  publish_confirmation_message: 'Publicar el Tipo de Documento lo hará visible para que los usuarios puedan crear Documentos de este tipo.',
  defuse_confirmation_title: '¿Estás seguro de despublicar este Tipo de Documento?',
  defuse_confirmation_message: 'Si despublicas este Tipo de Documento no podrás crear nuevos documentos en el futuro. Si podrás ver los documentos creados.',
  update_template: 'Actualizar template',
  create_template_name: 'Crea un nombre para el template',
  template_reference_name: 'Nombre de referencia para el template',
  document_type_not_published: 'El tipo de documento aún no está disponible.'
}

const processtypesView = {
  start: 'Iniciar',
  process_types_generator: 'Generador de Tipos de trámite',
  process_types_edit: 'Editar Tipo de trámite',
  process_type_name: 'Nombre del Tipo de Trámite',
  process_type_name_placeholder: 'Ingrese el nombre del Tipo de Trámite',
  process_type_alias: 'Alias del Tipo de Trámite',
  process_type_alias_placeholder: 'Ingrese el alias del Tipo de Trámite',
  process_type_description: 'Descripción del Trámite',
  process_type_description_placeholder: 'Esta descripción se mostrará como ayuda durante el alta del trámite',
  numerator_type: 'Tipo de Numerador',
  comunicable_type: 'Tipo de Comunicación',
  visibility_type: 'Tipo de Visibilidad',
  signature_type: 'Tipo de Firma',
  numerator_prefix: 'Prefjo para numeración',
  numerator_prefix_help: 'Grupo de letras que se antepondrán al número del trámite para identificarlo',
  comments_type_help: 'Esta opción permite habilitar y administrar los comentarios para este tipo de trámite.',
  import_form_components_from_another_process_type: 'Cargar campos desde otro tipo de trámite',
  process_publish_confirmation_title: '¿Estás seguro de publicar este Tipo de Trámite?',
  process_publish_confirmation_message: 'Publicar el Tipo de Trámite lo hará visible para que los usuarios puedan crear Trámite de este tipo.',
  process_defuse_confirmation_title: '¿Estás seguro de despublicar este Tipo de Trámite?',
  process_defuse_confirmation_message: 'Si despublicas este Tipo de Trámite no podrás crear nuevos trámites en el futuro. Si podrás ver los trámites creados.',
  update_template: 'Actualizar template',
  create_template_name: 'Crea un nombre para el template',
  template_reference_name: 'Nombre de referencia para el template',
  save_and_publish: 'Guardar y Publicar',
  clasification: 'Clasificación',
  clasification_help: 'Esta opción permite definir si los trámites serán iniciados sólo por áreas internas o si también lo pueden iniciar personas humanas/jurídicas',
  internal: 'Interno',
  public: 'Público',
  tad_available: 'Disponible TAD',
  tad_available_help: 'Esta opción permite definir si el trámite puede ser iniciado desde el módulo de TAD',
  process_prefix: 'Prefjo para numeración',
  process_prefix_help: 'Grupo de letras que se antepondrán al número del trámite para identificarlo',
  workflow: 'Workflow',
  process_workflow: '',
  process_workflow_help: '',
  start_process: 'Iniciar Trámite',
  change_peopletype: 'Modificar Tipo de Persona',
  custom_initiator: 'Iniciador personalizado',
  add_custom_initiator: 'Agregar iniciador',
  custom_initiator_name: 'Nombre del Iniciador',
  custom_initiator_name_placeholder: 'Ingrese el nombre del iniciador',
  custom_initiator_desc: 'Descripción del Iniciador',
  custom_initiator_desc_placeholder: 'Ingrese la descripción del iniciador',
  initiator_types: 'Tipos de Iniciadores',
  initiator_types_generator: 'Generador de Tipos de Iniciadores',
  initiator_types_edit: 'Editar Tipo de Iniciador',
  initiator_type_name: 'Nombre del Tipo de Iniciador',
  initiator_type_name_placeholder: 'Ingrese el nombre del Tipo de Iniciador',
  initiator_type_alias: 'Alias del Tipo de Iniciador',
  initiator_type_alias_placeholder: 'Ingrese el alias del Tipo de Iniciador',
  initiator_type_description: 'Descripción del Tipo de Iniciador',
  initiator_type_description_placeholder: 'Esta descripción se mostrará como ayuda durante el alta del iniciador',
  import_form_components_from_another_initiator_type: 'Cargar campos desde otro tipo de iniciador',
  initiator_publish_confirmation_title: '¿Estás seguro de publicar este Tipo de Iniciador?',
  initiator_publish_confirmation_message: 'Publicar el Tipo de Iniciador lo hará visible para que los usuarios puedan crear iniciadores de este tipo. No podrás editar sus características una vez publicado',
  initiator_defuse_confirmation_title: '¿Estás seguro de despublicar este Tipo de Iniciador?',
  initiator_defuse_confirmation_message: 'Si despublicas este Tipo de Iniciador no podrás crear nuevos iniciadores en el futuro. Si podrás ver los iniciadores creados.',
  initiator_id: 'Identificador',
  initiator_id_placeholder: 'Seleccione el campo identificador',
  initiator_id_help: 'Este campo será el identificador del iniciador. Será utilizado para mostrarse en listados y poder buscar entre todos los trámites. Debe ser un selector en árbol y será requerido en la creación del trámite.',
  area_pass: 'Pases',
  area_pass_help: 'Está opción define si se puede realizar un pase en el trámite',
  process_type_not_published: 'El tipo de trámite aún no está disponible.',
  integration_available: 'Activar Integraciones',
  integration_available_help: 'Esta opción permite definir si el trámite puede ser iniciado via APIs'
}

const processView = {
  changes_unsaved: 'Tienes cambios sin guardar',
  changes_unsaved_subtitle: 'Los cambios se perderán si continuas.',
  no_associated_processes: 'No hay trámites asociados',
  show_cover: 'Carátula',
  update_cover: 'Actualizar carátula',
  just_save: 'Solo guardar',
  update_process: 'Editar trámite',
  initiator_data: 'Iniciador',
  additional_initiator_data: 'Iniciadores Adicionales',
  associated: 'Asociaciones',
  cover_affected: 'Estos cambios impactan en la carátula ¿desea generarla?',
  requester: 'Solicitante',
  choose_a_requester_step: 'Selección del iniciador',
  process_configuration_step: 'Configuración del trámite',
  add_documents_step: 'Agrega Documentos',
  confirmation_step: 'Confirmación',
  search_already_created: 'Buscar Existente',
  create_a_new_one: 'Crear Nuevo',
  do_movement: 'Realizar pase',
  person_doesnt_exists: 'La persona no existe',
  person_doesnt_exists_detail: 'No hay una persona con el identificador ingresado, ¿querés crearla ahora?',
  save_process_succeded: 'Se guardó el trámite correctamente.',
  save_succeded_with_processname: 'Se guardó el trámite "{processName}" correctamente.',
  create_process_succeded: 'Se creó el trámite "{processName}" correctamente.',
  process: {
    confirmations: {
      start_confirmation_with_processname: 'Se {actionName} el trámite "{processName}" correctamente.',
      movement_confirmation: 'El trámite "{processName}" se transfirió a "{processDestination}".',
      take_confirmation: 'Estás a punto de tomar el trámite. ¿Querés continuar?'
    }
  },
  take_process_succeded: 'El trámite "{processName}" ahora está en tu posesión.',
  process_relation_succeded: 'El trámite "{processName}" se asoció correctamente.',
  multiple_process_relation_succeded: 'Los trámites se asociaron correctamente.',
  edit_initiator: 'Editar iniciador',
  select_a_request_starter: 'Seleccione a quién solicitar iniciar el trámite',
  current_location: 'Ubicación Actual',
  cover_updated_succeded: 'Se actualizó la portada correctamente.',
  go_back_to_process: 'Volver al Trámite',
  parcelarias_remove_nomenclatura_confirmation: 'Estás a punto de eliminar nomenclaturas del trámite. ¿Querés continuar?'
}

const peopletypesView = {
  people_types: 'Tipos de Persona',
  people_types_generator: 'Generador de Tipos de Persona',
  people_types_edit: 'Editar Tipo de Persona',
  people_type_name: 'Nombre del Tipo de Persona',
  people_type_name_placeholder: 'Ingrese el nombre del Tipo de Persona',
  people_type_alias: 'Alias del Tipo de Persona',
  people_type_alias_placeholder: 'Ingrese el alias del Tipo de Persona',
  people_type_description: 'Descripción del Tipo de Persona',
  people_type_description_placeholder: 'Esta descripción se mostrará como ayuda durante el alta de la persona',
  people_publish_confirmation_title: '¿Estás seguro de publicar este Tipo de Persona?',
  people_publish_confirmation_message: 'Publicar el Tipo de Persona lo hará visible para que los usuarios puedan crear personas de este tipo. No podrás editar sus características una vez publicado',
  people_defuse_confirmation_title: '¿Estás seguro de despublicar este Tipo de Persona?',
  people_defuse_confirmation_message: 'Si despublicas este Tipo de Persona no podrás crear nuevas personas en el futuro. Si podrás ver las personas creadas.',
  import_form_components_from_another_people_type: 'Cargar campos desde otro tipo de persona',
  people_name: 'Nombre o Razón Social',
  people_name_placeholder: 'Ingrese el nombre o razón social',
  people_idtype: 'Tipo de Identificador',
  people_idtype_help: 'Selecciona con qué tipos se podrán idenfitificar las personas creadas',
  people_id_number: 'Número de Identificador',
  people_id_number_placeholder: 'Ingrese el número de Identificador',
  people_type_not_published: 'El tipo de persona aún no está disponible.'
}

const documentsView = {
  send_to_sign: 'Enviar a Firmar',
  save_as_draft: 'Guardar como borrador',
  start_document: 'Iniciar',
  select_a_content_template: 'Seleccione un template de contenido',
  lm_recipients_subtitle: 'Seleccione los usuarios o áreas que van a recibir el documento una vez finalizado.',
  lm_sharewith_subtitle: 'Seleccione los usuarios que van a realizar el seguimiento del documento.',
  lm_participants_title: 'Participantes',
  lm_fixed_participants_title: 'Participantes predefinidos',
  lm_participants_subtitle: 'Seleccione los usuarios que van a participar de este documento.',
  lm_workflow_subtitle: 'Defina el workflow de este documento.',
  lm_sharewith_empty_title: 'Todavía no se han seleccionado usuarios para compartir este documento',
  review: 'Revisar',
  approve: 'Aprobar',
  select_new_status: 'Seleccione el nuevo estado',
  document_configuration: 'Configuración de documento',
  communication: 'Comunicación',
  optimizing_content: 'Optimizando contenido',
  only_fillable_fields: 'Solo se muestran los campos que debes completar.',
  show_full_document: 'Mostrar Documento completo',
  recipients: 'Destinatarios',
  share_with: 'Compartir con',
  viewers: 'Visualizadores',
  document: 'Documento',
  token_code_sent: 'Un código fue enviado a su mail, por favor ingreselo a continuación.',
  sign: 'Firmar',
  sign_multiple: 'Firmar ({count})',
  inperson_sign: 'Firmar {name}',
  preview: 'Vista Previa',
  resend_email: 'Reenviar Email a {name}',
  take: 'Tomar',
  reject_confirmation: '¿Estas seguro de que deseas rechazar este Documento?',
  document_access_denied: 'No te asignaron permisos para visualizar este documento.',
  view_document: 'Ver documento',
  document_created_success_msg: 'El documento "{documentName}" se creó y podrás continuar editándolo cuando desees.',
  document_updated_success_msg: 'El documento "{documentName}" se guardó y podrás continuar editándolo cuando desees.',
  document_updated_success_shared_editor_msg: 'El documento "{documentName}" se guardó.',
  document_started_success_msg: 'El documento "{documentName}" se inició exitosamente.',
  document_signed_success_msg: 'El documento "{documentName}" se firmó exitosamente.',
  document_inperson_signed_success_msg: 'El documento "{documentName}" se firmó exitosamente de forma presencial.',
  document_approved_success_msg: 'El documento "{documentName}" se aprobó exitosamente.',
  after_start_sign_multiple_message: 'Se envió a firmar {count} documento, recibirás una notificación cuando finalice la tarea. | Se envió a firmar {count} documentos, recibirás las notificaciónes cuando finalicen las tareas.',
  confirmations: {
    inperson_start_sign_confirmation: '<h4>{name} va a iniciar el proceso de firma del documento.<br><br></h4>',
    start_sign_confirmation: '<h4>Va a iniciar el proceso de firma del documento.<br><br></h4>',
    start_sign_multiple_confirmation: '<h4>Va a iniciar el proceso de firma de {count} documento.<br><br></h4> |<h4>Va a iniciar el proceso de firma de {count} documentos.<br><br></h4>',
    review_confirmation: '<h4>Está por aprobar el documento.<br><br><small class="text-muted">Esto lo enviará al próximo participante.</small></h4>',
    remove_editor_confirmation: 'Para cambiar o eliminar editores podés hacerlo desde el formulario.',
    start_document_confirmation: 'Se inició "{documentName}" correctamente.',
    immediate_review_document: '¿Quieres iniciar y revisar automáticamente el documento?',
    immediate_sign_document: '¿Quieres iniciar y firmar automáticamente el documento?',
    immediate_review_document_v1: '¿Quieres revisar automáticamente el documento?',
    immediate_sign_document_v1: '¿Quieres firmar automáticamente el documento?'
  },
  related_process: 'Trámite asociado',
  related_processes: 'Trámites asociados',
  related_processes_count: '{processCount} trámites asociados',
  sign_here: 'Firme aquí',
  clear_signature: 'Limpiar',
  sign_action: 'Firma',
  sign_action_inperson: 'Firma Presencial',
  review_action: 'Revisa',
  workflow_fixed_section_title: 'Sección Fija 📌',
  workflow_dynamic_section_title: 'Sección Libre 📥'
}

const listbuilderView = {
  data_origin: 'Origen de datos',
  help_data_origin: 'Origen de datos del listado',
  placeholder_origen_de_datos: 'Seleccione una opción',
  help_alias: 'Alias para identificar el formulario en el listado',
  label_titulo_listado: 'Título del listado',
  help_titulo_listado: 'Título del listado',
  titulo_ventana_busqueda_inicial: 'Búsqueda Inicial',
  description_busqueda_inicial: 'Haga una búsqueda inicial para prefiltrar y ordenar los resultados.',
  label_busqueda_inicial: 'Búsqueda inicial',
  help_busqueda_inicial: 'Prefiltrado con búsqueda',
  help_busqueda_meta: 'Filtrado en base a los datos de sesión del usuario',
  label_busqueda_meta: 'Meta búsqueda',
  label_ordenar_por: 'Ordenar por',
  help_ordenar_por: 'Orden inicial',
  btn_agregar_busqueda: 'Aplicar búsqueda',
  btn_aplicar_columnas: 'Aplicar columnas',
  titulo_ventana_botones: 'Botones',
  label_valor: 'Valor',
  placeholder_valor: 'Nuevo formulario',
  label_to: 'Ruta',
  placeholder_to: '/listbuilderui/',
  label_endpointToValidateVisibility: 'Ruta que valida visibilidad',
  placeholder_endpointToValidateVisibility: '/endpoint/',
  label_mostrar: 'Visible',
  label_checkbox_deshabilitar: 'Deshabilitado',
  label_color: 'Color de fondo',
  btn_agregar_boton: 'Agregar botón',
  titulo_ventana_paginado: 'Paginado',
  label_pagina: 'Página',
  help_pagina: 'Número de página que iniciará el listado',
  label_perpage: 'Cantidad por página',
  help_perpage: 'Cantidad de items a listar',
  btn_aplicar_paginado: 'Aplicar paginado',
  titulo_ventana_acciones: 'Acciones',
  label_types: 'Tipos:',
  placeholder_modal_endpoint: '/endpoint/',
  label_modal_endpoint: 'Ruta',
  label_modal_requestMethod: 'Método de petición',
  disabled_option: 'Seleccione una opción',
  label_modal_delayAfterSubmit: 'Retraso tras el envío',
  placeholder_modal_delayAfterSubmit: 'Delay',
  placeholder_modal_title: 'Título modal',
  label_modal_title: 'Título',
  label_modal_tooltip: 'Descripción emergente',
  placeholder_modal_tooltip: 'Descripción',
  label_modal_message: 'Mensaje',
  placeholder_modal_message: 'Mensaje',
  label_isComment: 'Comentario ( textarea )',
  label_modal_labelComment: 'Título',
  placeholder_modal_labelComment: 'Título textarea',
  label_modal_required: 'Requerido',
  label_modal_fontAwesomeIcon: 'Ícono (fontawesome)',
  label_modal_fontAwesomeIcon_small: 'Todos los íconos: ',
  name_path: 'Ruta',
  name_modal: 'Modal',
  label_action_tooltip: 'Descripción emergente',
  placeholder_action_tooltip: 'Descripción',
  label_action_to: 'Ruta',
  placeholder_action_to: '/listbuilder/edit/:_id',
  btn_agregar_action: 'Agregar acción',
  titulo_ventana_modo: 'Modo',
  label_modo_listado: 'Listado',
  label_modo_mapa: 'Mapa',
  titulo_ventana_preview: 'Vista previa',
  titulo_sin_privilegios: 'Lo sentimos, no tiene permisos para guardar los cambios.',
  ver_el_ultimo_cargado: '👉 Ver el último listado cargado',
  listado_de_listados: 'Listado de Listados',
  label_modo_caja: 'Caja',
  btn_agragar_modo: 'Aplicar modo',
  label_cantidad_filas: 'Filas',
  label_titulo: 'Título',
  label_categoria: 'Categoría',
  label_contenido: 'Contenido',
  placeholder_columna: 'Columna',
  label_borde_superior: 'Borde superior',
  label_color_borde_superior: 'Color borde superior',
  titulo_ventana_aggregations: 'Filtros',
  btn_agregar_aggregations: 'Agregar filtro',
  placeholder_título_filtro: 'Título del filtro',
  titulo_acciones: 'Acciones',
  titulo_modals: 'Modals',
  titulo_columnas: 'Columnas',
  label_columnas: 'Seleccione las columnas que se mostrarán en el listado.',
  titulo_busqueda: 'Búsqueda',
  label_columnas_busqueda: 'Seleccione las columnas para buscar en el campo de búsqueda.',
  titulo_columns_busqueda: 'Columnas de búsqueda',
  titulo_columns_listado: 'Columnas del listado',
  caracteres_titulo: 'Caracteres en título',
  caracteres_categoria: 'Caracteres en categoría',
  caracteres_contenido: 'Caracteres en contenido',
  alto_minimo: 'Alto mínimo'
}

const widgets = {
  quantity: 'Cantidad',
  result_quantity: 'Cantidad de resultado',
  help_quantity: 'Limita la cantidad de resultados a mostrar en el gráfico'
}

const datatables = {
  wait_for_csv_completion: 'Estamos extrayendo los datos del listado y generando el archivo zip, te avisaremos cuando este listo para ser descargado.',
  csv_generate_confirmation: 'Va a descargar el listado "{name}" con todos sus filtros y la búsqueda realizada ({count} registros aprox.).  Este proceso puede demorar, está seguro? '
}

const esLocales = Object.assign({},
  es,
  general,
  accion,
  formbuilderView,
  listbuilderView,
  formbuilderComponents,
  documenttypesView,
  processView,
  processtypesView,
  peopletypesView,
  documentsView,
  widgets,
  library,
  groupUsers,
  groupReviewers,
  groupProfile,
  datatables
)

export default esLocales
